import styles from "../ourCars.module.css";
import { CarStylesProps } from "../types";

const CarStyles = ({ styleList, isSmView, viewCarsDivHeight }: CarStylesProps) => {
  const botbStyles = [{ Key: "All Styles", Value: "All Styles", Link: "/prizes/cars" }, ...styleList];
  if (isSmView) {
    return (
      <>
        <h3 className="font-medium filterSubHeaders">STYLES</h3>
        <ul
          style={{
            height: `calc(100% - ${viewCarsDivHeight}px)`,
            overflowY: "auto",
          }}>
          {botbStyles.map((style, index) => (
            <li key={index} className="py-2">
              {style.Link === null ? (
                <span className={styles.inactiveMake}>{style.Key}</span>
              ) : (
                <a className={styles.activeMake} href={style.Link}>
                  {style.Value}
                </a>
              )}
            </li>
          ))}
        </ul>
      </>
    );
  }
  return (
    <div className="border-2 bg-white p-4">
      <ul className="flex">
        <li className={`${styles.botbStyleSvgCars} mx-5`}>
          <a href="/app/(general-header)/prizes/cars/win-a-suv">
            <svg>
              <use xlinkHref="/assets/svgs/prize-styles.svg#icon-SUV-UNSELECTED" />
            </svg>
          </a>
        </li>
        <li className={`${styles.botbStyleSvgCars} mx-5`}>
          <a href="/app/(general-header)/prizes/cars/win-a-convertible">
            <svg>
              <use xlinkHref="/assets/svgs/prize-styles.svg#icon-CONVERTIBLE-UNSELECTED" />
            </svg>
          </a>
        </li>
        <li className={`${styles.botbStyleSvgCars} mx-5`}>
          <a href="/app/(general-header)/prizes/cars/win-a-coupe">
            <svg>
              <use xlinkHref="/assets/svgs/prize-styles.svg#icon-COUPE-UNSELECTED" />
            </svg>
          </a>
        </li>
        <li className={`${styles.botbStyleSvgCars} mx-5`}>
          <a href="/app/(general-header)/prizes/cars/win-a-hot-hatchback">
            <svg>
              <use xlinkHref="/assets/svgs/prize-styles.svg#icon-HOTHATCH-UNSELECTED" />
            </svg>
          </a>
        </li>
        <li className={`${styles.botbStyleSvgCars} mx-5`}>
          <a href="/app/(general-header)/prizes/cars/win-an-electric-car">
            <svg>
              <use xlinkHref="/assets/svgs/prize-styles.svg#icon-HYBRID-UNSELECTED" />
            </svg>
          </a>
        </li>
        <li className={`${styles.botbStyleSvgCars} mx-5`}>
          <a href="/app/(general-header)/prizes/cars/win-a-sports-car">
            <svg>
              <use xlinkHref="/assets/svgs/prize-styles.svg#icon-SPORTS-UNSELECTED" />
            </svg>
          </a>
        </li>
      </ul>
      <div className="grid grid-cols-5 gap-4 mt-4">
        {botbStyles.map((style, index) =>
          style.Link === null ? (
            <span className={styles.inactiveMake} key={index}>
              {style.Key}
            </span>
          ) : (
            <a className={styles.activeMake} key={index} href={style.Link}>
              {style.Value}
            </a>
          )
        )}
      </div>
    </div>
  );
};

export default CarStyles;
